export default "__VITE_ASSET__D5e4DPk1__"